import Vue from 'vue'
import Vuex from 'vuex'

import articulo from './modules/articulo'
import articulos from './modules/articulos'
import articulosStock from './modules/articulosStock'
import articuloTipo from './modules/articuloTipo'
import articulosTipos from './modules/articulosTipos'
import banco from './modules/banco'
import bancos from './modules/bancos'
import bancochequera from './modules/bancochequera'
import bancoschequeras from './modules/bancoschequeras'
import bancocuenta from './modules/bancocuenta'
import bancoscuentas from './modules/bancoscuentas'
import bancocuentacierre from './modules/bancocuentacierre'
import bancomovimiento from './modules/bancomovimiento'
import bancosmovimientos from './modules/bancosmovimientos'
import bancomovimientotipo from './modules/bancomovimientotipo'
import bancosmovimientostipos from './modules/bancosmovimientostipos'
import bancoMovimientoDeposito from './modules/bancoMovimientoDeposito'
import bancoMovimientoDivisas from './modules/bancoMovimientoDivisas'
import bien from './modules/bien'
import bienDatos from './modules/bienDatos'
import bienes from './modules/bienes'
import bienRubro from './modules/bienRubro'
import bienesRubros from './modules/bienesRubros'
import brief from './modules/brief'
import briefDatos from './modules/briefDatos'
import briefs from './modules/briefs'
import briefAdicional from './modules/briefAdicional'
import briefCambio from './modules/briefCambio'
import briefEntrega from './modules/briefEntrega'
import briefsEntregas from './modules/briefsEntregas'
import briefTarea from './modules/briefTarea'
import briefsTareas from './modules/briefsTareas'
import briefsTareasDashboard from './modules/briefsTareasDashboard'
import briefTareaEstado from './modules/briefTareaEstado'
import briefsTareasEstados from './modules/briefsTareasEstados'
import caja from './modules/caja'
import cajas from './modules/cajas'
import cajasmovimientos from './modules/cajasmovimientos'
import cajaregistro from './modules/cajaregistro'
import cajasregistros from './modules/cajasregistros'
import cajatransferencia from './modules/cajatransferencia'
import cajastransferencias from './modules/cajastransferencias'
import canal from './modules/canal'
import canales from './modules/canales'
import cancelacionmotivo from './modules/cancelacionmotivo'
import cancelacionesmotivos from './modules/cancelacionesmotivos'
import cargo from './modules/cargo'
import cargos from './modules/cargos'
import categoriasServicios from './modules/categoriasServicios'
import celular from './modules/celular'
import celularDatos from './modules/celularDatos'
import certificadoServicio from './modules/certificadoServicio'
import certificadosServicio from './modules/certificadosServicio'
import cliente from './modules/cliente'
import clientecontacto from './modules/clientecontacto'
import clientecontactoadministracion from './modules/clientecontactoadministracion'
import clienteRebate from './modules/clienteRebate'
import clienteRebateDatos from './modules/clienteRebateDatos'
import clientes from './modules/clientes'
import clientescontactos from './modules/clientescontactos'
import cobro from './modules/cobro'
import cobros from './modules/cobros'
import compra from './modules/compra'
import compras from './modules/compras'
import comprapercepcionesprovinciales from './modules/comprapercepcionesprovinciales'
import compraspercepcionesprovinciales from './modules/compraspercepcionesprovinciales'
import compraImpuesto from './modules/compraImpuesto'
import comprasImpuestos from './modules/comprasImpuestos'
import computadora from './modules/computadora'
import computadoraDatos from './modules/computadoraDatos'
import condicionesfiscales from './modules/condicionesfiscales'
import controlStock from './modules/controlStock'
import controlesStock from './modules/controlesStock'
import cotizador from './modules/cotizador'
import cuenta from './modules/cuenta'
import cuentas from './modules/cuentas'
import cuentacorrienteclientes from './modules/cuentacorrienteclientes'
import cuentacorrienteproveedores from './modules/cuentacorrienteproveedores'
import cuentacorrientevendedores from './modules/cuentacorrientevendedores'
import cuentasIngresosGastos from './modules/cuentasIngresosGastos'
import chequepropio from './modules/chequepropio'
import chequetercero from './modules/chequetercero'
import chequesterceros from './modules/chequesterceros'
import chequespropios from './modules/chequespropios'
import documentostipos from './modules/documentostipos'
import empresa from './modules/empresa'
import empresas from './modules/empresas'
import encuestaUsuario from './modules/encuestaUsuario'
import encuestaUsuarioDatos from './modules/encuestaUsuarioDatos'
import encuestasUsuarios from './modules/encuestasUsuarios'
import encuestasUsuariosTipos from './modules/encuestasUsuariosTipos'
import estadosCiviles from './modules/estadosCiviles'
import etiquetaProveedor from './modules/etiquetaProveedor'
import etiquetasProveedores from './modules/etiquetasProveedores'
import evaluacionProveedor from './modules/evaluacionProveedor'
import evaluacionesProveedores from './modules/evaluacionesProveedores'
import facturaelectronica from './modules/facturaelectronica'
import facturaProforma from './modules/facturaProforma'
import facturasProforma from './modules/facturasProforma'
import flujoFondos from './modules/flujoFondos'
import flujoFondosConceptos from './modules/flujoFondosConceptos'
import flujoFondosPresupuesto from './modules/flujoFondosPresupuesto'
import flujoFondosPresupuestos from './modules/flujoFondosPresupuestos'
import formapago from './modules/formapago'
import formaspago from './modules/formaspago'
import giroEmpresa from './modules/giroEmpresa'
import girosEmpresas from './modules/girosEmpresas'
import holistor from './modules/holistor'
import impuestoOrganismo from './modules/impuestoOrganismo'
import impuestosOrganismos from './modules/impuestosOrganismos'

import indicadores from './modules/indicadores'
import indicadoresPlazoProveedores from './modules/indicadoresPlazoProveedores'
import indicadoresRentabilidadBruta from './modules/indicadoresRentabilidadBruta'
import indicadoresRentabilidadNeta from './modules/indicadoresRentabilidadNeta'
import indicadoresVentasMixClientes from './modules/indicadoresVentasMixClientes'
import indicadorPlazo from './modules/indicadorPlazo'
import indicadorPlazoPago from './modules/indicadorPlazoPago'
import indicadorPorcentaje from './modules/indicadorPorcentaje'
import indicadorRentabilidadBruta from './modules/indicadorRentabilidadBruta'
import indicadorRentabilidadNeta from './modules/indicadorRentabilidadNeta'
import indicadorVentas from './modules/indicadorVentas'
import indicadorVentasMixClientes from './modules/indicadorVentasMixClientes'
import indicadorVentasTrimestral from './modules/indicadorVentasTrimestral'

import indicadoresCuentas from './modules/indicadoresCuentas'
import indicadoresProduccion from './modules/indicadoresProduccion'
import indicadoresSocios from './modules/indicadores/indicadoresSocios'

import resultadosAdministracion from './modules/dashboard/resultadosAdministracion'
import resultadosComercial from './modules/dashboard/resultadosComercial'
import resultadosIndicadores from './modules/resultadosIndicadores'
import resultadosPresupuestos from './modules/dashboard/resultadosPresupuestos'
import resultadosRentabilidadBruta from './modules/dashboard/resultadosRentabilidadBruta'
import resultadosRentabilidadNeta from './modules/dashboard/resultadosRentabilidadNeta'
import resultadosVentas from './modules/dashboard/resultadosVentas'

import ingresoegreso from './modules/ingresoegreso'
import ingresosegresos from './modules/ingresosegresos'
import ingresoEgresoCuota from './modules/ingresoEgresoCuota'
import ingresosegresostipos from './modules/ingresosegresostipos'
import instruccionCobro from './modules/instruccionCobro'
import instruccionesCobros from './modules/instruccionesCobros'
import interesBancarioRubro from './modules/interesBancarioRubro'
import interesesBancariosRubros from './modules/interesesBancariosRubros'
import jurisdiccionesIngresosBrutos from './modules/jurisdiccionesIngresosBrutos'
import liquidacionSueldos from './modules/liquidacionSueldos'
import liquidacionSueldosFinal from './modules/liquidacionSueldosFinal'
import liquidacionesSueldos from './modules/liquidacionesSueldos'
import liquidacionSueldosPagos from './modules/liquidacionSueldosPagos'
import liquidacionSueldosPagoDatos from './modules/liquidacionSueldosPagoDatos'
import localidad from './modules/localidad'
import localidades from './modules/localidades'
import marca from './modules/marca'
import marcas from './modules/marcas'
import mensajes from './modules/mensajes'
import monedas from './modules/monedas'
import ordenfacturacionlogistica from './modules/ordenfacturacionlogistica'
import ordenesfacturacionlogistica from './modules/ordenesfacturacionlogistica'
import ordenproveedor from './modules/ordenproveedor'
import ordenproveedorformapago from './modules/ordenproveedorformapago'
import ordenesproveedores from './modules/ordenesproveedores'
import ordenSubtrabajo from './modules/ordenSubtrabajo'
import ordenesSubtrabajos from './modules/ordenesSubtrabajos'
import ordentrabajo from './modules/ordentrabajo'
import ordenestrabajo from './modules/ordenestrabajo'
import ordenTrabajoAlternativa from './modules/ordenTrabajoAlternativa'
import ordenTrabajoInterna from './modules/ordenTrabajoInterna'
import ordenestrabajosinternas from './modules/ordenestrabajosinternas'
import ordentrabajoproduccion from './modules/ordentrabajoproduccion'
import ordenestrabajosusuarios from './modules/ordenestrabajosusuarios'
import pago from './modules/pago'
import pagos from './modules/pagos'
import pais from './modules/pais'
import paises from './modules/paises'
import parametros from './modules/parametros'
import parametroinflacion from './modules/parametroinflacion'
import parametrosinflacion from './modules/parametrosinflacion'
import personal from './modules/personal'
import personalDatos from './modules/personalDatos'
import personalHijo from './modules/personalHijo'
import personalNovedad from './modules/personalNovedad'
import personalNovedades from './modules/personalNovedades'
import personalNovedadesCalendario from './modules/personalNovedadesCalendario'
import personel from './modules/personel'
import planCuentas from './modules/planCuentas'
import planPagos from './modules/planPagos'
import planesPagos from './modules/planesPagos'
import presupuestoCliente from './modules/presupuestoCliente'
import presupuestoGastos from './modules/presupuestoGastos'
import presupuestosGastos from './modules/presupuestosGastos'
import presupuestoGastosConcepto from './modules/presupuestoGastosConcepto'
import presupuestosGastosConceptos from './modules/presupuestosGastosConceptos'
import presupuestointerno from './modules/presupuestointerno'
import presupuestoInternoDatos from './modules/presupuestoInternoDatos'
import presupuestosinternos from './modules/presupuestosinternos'
import presupuestosinternoscancelados from './modules/presupuestosinternoscancelados'
import presupuestointernoproduccion from './modules/presupuestointernoproduccion'
import presupuestosinternosusuarios from './modules/presupuestosinternosusuarios'
import prioridades from './modules/prioridades'
import proveedor from './modules/proveedor'
import proveedores from './modules/proveedores'
import proveedorbancocuenta from './modules/proveedorbancocuenta'
import provincia from './modules/provincia'
import provincias from './modules/provincias'
import remito from './modules/remito'
import remitos from './modules/remitos'
import remitoEstado from './modules/remitoEstado'
import remitosEstados from './modules/remitosEstados'
import remitosFacturacion from './modules/remitosFacturacion'
import remitodestino from './modules/remitodestino'
import remitosdestinos from './modules/remitosdestinos'
import resumenGastos from './modules/resumenGastos'
import retencioncliente from './modules/retencioncliente'
import retencionesclientes from './modules/retencionesclientes'
import retencionProveedor from './modules/retencionProveedor'
import retenciontipo from './modules/retenciontipo'
import retencionestipos from './modules/retencionestipos'
import retencionregimen from './modules/retencionregimen'
import retencionesregimenes from './modules/retencionesregimenes'
import rubro from './modules/rubro'
import rubrotrabajo from './modules/rubrotrabajo'
import rubrostrabajos from './modules/rubrostrabajos'
import rubroTrabajoCliente from './modules/rubroTrabajoCliente'
import spinnerProcesando from './modules/spinner-procesando'
import subrubro from './modules/subrubro'
import tarjeta from './modules/tarjeta'
import tarjetacupon from './modules/tarjetacupon'
import tarjetascupones from './modules/tarjetascupones'
import tarjetamarca from './modules/tarjetamarca'
import tarjetasmarcas from './modules/tarjetasmarcas'
import tarjetaPlastico from './modules/tarjetaPlastico'
import tarjetaResumen from './modules/tarjetaResumen'
import tarjetaResumenCierre from './modules/tarjetaResumenCierre'
import tarjetaResumenCierreSaldos from './modules/tarjetaResumenCierreSaldos'
import tarjetaResumenPago from './modules/tarjetaResumenPago'
import tarjetaResumenVencimiento from './modules/tarjetaResumenVencimiento'
import tarjetas from './modules/tarjetas'
import tarjetasPlasticos from './modules/tarjetasPlasticos'
import tarjetasResumenes from './modules/tarjetasResumenes'
import tarjetasResumenesPagos from './modules/tarjetasResumenesPagos'
import tarjetasResumenesVencimientos from './modules/tarjetasResumenesVencimientos'
import tipoDisenio from './modules/tipoDisenio'
import tipoNovedad from './modules/tipoNovedad'
import tipoPresupuesto from './modules/tipoPresupuesto'
import tiposDisenios from './modules/tiposDisenios'
import tiposNovedades from './modules/tiposNovedades'
import tiposPresupuestos from './modules/tiposPresupuestos'
import transferencia from './modules/transferencia'
import transferenciasclientes from './modules/transferenciasclientes'
import transferenciaPremios from './modules/transferenciaPremios'
import transferenciaPremiosPresupuesto from './modules/transferenciaPremiosPresupuesto'
import transferenciasPremios from './modules/transferenciasPremios'
import transferenciasPremiosImputacion from './modules/transferenciasPremiosImputacion'
import transferenciasPremiosImputaciones from './modules/transferenciasPremiosImputaciones'
import transferenciasproveedores from './modules/transferenciasproveedores'
import user from './modules/user'
import usuario from './modules/usuario'
import usuarios from './modules/usuarios'
import usuariosroles from './modules/usuariosroles'
import usuarioperfil from './modules/usuarioperfil'
import vendedor from './modules/vendedor'
import vendedores from './modules/vendedores'
import venta from './modules/venta'
import ventas from './modules/ventas'
import ventaNegociacion from './modules/ventaNegociacion'
import ventasNegociaciones from './modules/ventasNegociaciones'
import viatico from './modules/viatico'
import viaticoDatos from './modules/viaticoDatos'
import viaticoRubro from './modules/viaticoRubro'
import viaticos from './modules/viaticos'
import viaticoPago from './modules/viaticoPago'
import viaticoRendicion from './modules/viaticoRendicion'
import viaticosRubros from './modules/viaticosRubros'

import presupuestointernoprocess from './processes/presupuestointerno'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    articulo,
    articulos,
    articulosStock,
    articuloTipo,
    articulosTipos,
    banco,
    bancochequera,
    bancocuenta,
    bancocuentacierre,
    bancos,
    bancoschequeras,
    bancoscuentas,
    bancomovimiento,
    bancosmovimientos,
    bancomovimientotipo,
    bancosmovimientostipos,
    bancoMovimientoDeposito,
    bancoMovimientoDivisas,
    bien,
    bienDatos,
    bienes,
    bienRubro,
    bienesRubros,
    brief,
    briefDatos,
    briefs,
    briefAdicional,
    briefCambio,
    briefEntrega,
    briefsEntregas,
    briefTarea,
    briefsTareas,
    briefsTareasDashboard,
    briefTareaEstado,
    briefsTareasEstados,
    caja,
    cajas,
    cajasmovimientos,
    cajaregistro,
    cajasregistros,
    cajatransferencia,
    cajastransferencias,
    canal,
    canales,
    cancelacionmotivo,
    cargo,
    cargos,
    categoriasServicios,
    cancelacionesmotivos,
    celular,
    celularDatos,
    certificadoServicio,
    certificadosServicio,
    cliente,
    clientecontacto,
    clientecontactoadministracion,
    clienteRebate,
    clienteRebateDatos,
    clientes,
    clientescontactos,
    cobro,
    cobros,
    compra,
    compras,
    comprapercepcionesprovinciales,
    compraImpuesto,
    comprasImpuestos,
    compraspercepcionesprovinciales,
    computadora,
    computadoraDatos,
    controlStock,
    controlesStock,
    condicionesfiscales,
    cotizador,
    cuenta,
    cuentas,
    cuentacorrienteclientes,
    cuentacorrienteproveedores,
    cuentacorrientevendedores,
    cuentasIngresosGastos,
    chequepropio,
    chequespropios,
    chequetercero,
    chequesterceros,
    documentostipos,
    empresa,
    empresas,
    encuestaUsuario,
    encuestaUsuarioDatos,
    encuestasUsuarios,
    encuestasUsuariosTipos,
    estadosCiviles,
    etiquetaProveedor,
    etiquetasProveedores,
    evaluacionProveedor,
    evaluacionesProveedores,
    facturaelectronica,
    facturaProforma,
    facturasProforma,
    flujoFondos,
    flujoFondosConceptos,
    flujoFondosPresupuesto,
    flujoFondosPresupuestos,
    formapago,
    formaspago,
    giroEmpresa,
    girosEmpresas,
    holistor,
    // impuesto,
    // impuestos,
    impuestoOrganismo,
    impuestosOrganismos,

    indicadores,
    indicadorPorcentaje,

    indicadores,
    indicadoresPlazoProveedores,
    indicadoresRentabilidadBruta,
    indicadoresRentabilidadNeta,
    indicadoresVentasMixClientes,
    indicadorPlazo,
    indicadorPlazoPago,
    indicadorPorcentaje,
    indicadorRentabilidadBruta,
    indicadorRentabilidadNeta,
    indicadorVentas,
    indicadorVentasMixClientes,
    indicadorVentasTrimestral,

    indicadoresCuentas,
    indicadoresProduccion,
    indicadoresSocios,

    resultadosAdministracion,
    resultadosComercial,
    resultadosIndicadores,
    resultadosPresupuestos,
    resultadosRentabilidadBruta,
    resultadosRentabilidadNeta,
    resultadosVentas,

    ingresoegreso,
    ingresosegresos,
    ingresoEgresoCuota,
    ingresosegresostipos,
    instruccionCobro,
    instruccionesCobros,
    interesBancarioRubro,
    interesesBancariosRubros,
    jurisdiccionesIngresosBrutos,
    liquidacionSueldos,
    liquidacionSueldosFinal,
    liquidacionesSueldos,
    liquidacionSueldosPagos,
    liquidacionSueldosPagoDatos,
    localidad,
    localidades,
    marca,
    marcas,
    mensajes,
    monedas,
    ordenfacturacionlogistica,
    ordenesfacturacionlogistica,
    ordenproveedor,
    ordenproveedorformapago,
    ordenesproveedores,
    ordentrabajo,
    ordenSubtrabajo,
    ordenesSubtrabajos,
    ordenestrabajo,
    ordenTrabajoAlternativa,
    ordenTrabajoInterna,
    ordenestrabajosinternas,
    ordentrabajoproduccion,
    ordenestrabajosusuarios,
    pago,
    pagos,
    pais,
    paises,
    parametros,
    parametroinflacion,
    parametrosinflacion,
    personal,
    personalDatos,
    personalHijo,
    personalNovedad,
    personalNovedades,
    personalNovedadesCalendario,
    personel,
    planCuentas,
    planPagos,
    planesPagos,
    presupuestoCliente,
    presupuestoGastos,
    presupuestosGastos,
    presupuestoGastosConcepto,
    presupuestosGastosConceptos,
    presupuestointerno,
    presupuestoInternoDatos,
    presupuestosinternos,
    presupuestosinternoscancelados,
    presupuestointernoproduccion,
    presupuestosinternosusuarios,
    prioridades,
    proveedor,
    proveedores,
    proveedorbancocuenta,
    provincia,
    provincias,
    remito,
    remitos,
    remitoEstado,
    remitosEstados,
    remitosFacturacion,
    remitodestino,
    remitosdestinos,
    resumenGastos,
    retencioncliente,
    retencionesclientes,
    retencionProveedor,
    retencionregimen,
    retencionesregimenes,
    retenciontipo,
    retencionestipos,
    rubro,
    rubrotrabajo,
    rubrostrabajos,
    rubroTrabajoCliente,
    spinnerProcesando,
    subrubro,
    tarjeta,
    tarjetacupon,
    tarjetamarca,
    tarjetaPlastico,
    tarjetaResumen,
    tarjetaResumenCierre,
    tarjetaResumenCierreSaldos,
    tarjetaResumenPago,
    tarjetaResumenVencimiento,
    tarjetas,
    tarjetascupones,
    tarjetasmarcas,
    tarjetasPlasticos,
    tarjetasResumenes,
    tarjetasResumenesPagos,
    tarjetasResumenesVencimientos,
    tipoDisenio,
    tipoNovedad,
    tipoPresupuesto,
    tiposDisenios,
    tiposNovedades,
    tiposPresupuestos,
    transferencia,
    transferenciasclientes,
    transferenciaPremios,
    transferenciaPremiosPresupuesto,
    transferenciasPremios,
    transferenciasPremiosImputacion,
    transferenciasPremiosImputaciones,
    transferenciasproveedores,
    user,
    usuario,
    usuarios,
    usuariosroles,
    usuarioperfil,
    vendedor,
    vendedores,
    venta,
    ventas,
    ventaNegociacion,
    ventasNegociaciones,
    viatico,
    viaticoDatos,
    viaticoRubro,
    viaticos,
    viaticoPago,
    viaticoRendicion,
    viaticosRubros,

    presupuestointernoprocess,
  },
})
